export const PROCUREMENT_PERMS = {
  READ_PROCUREMENT_OVERVIEW: 'READ_PROCUREMENT_OVERVIEW',
  READ_REQUISITION: 'READ_REQUISITION',
  CREATE_REQUISITION: 'CREATE_REQUISITION',
  UPDATE_REQUISITION: 'UPDATE_REQUISITION',
  DELETE_REQUISITION: 'DELETE_REQUISITION',
  REQUISITION_SUBMIT: 'REQUISITION_SUBMIT',
  REQUISITION_APPROVE_VESSEL: 'REQUISITION_APPROVE_VESSEL',
  REQUISITION_APPROVE_SHORE: 'REQUISITION_APPROVE_SHORE',
  REQUISITION_ADD_ITEMS: 'REQUISITION_ADD_ITEMS',
  REQUISITION_DOWNLOAD: 'REQUISITION_DOWNLOAD',
  REQUISITION_EXPORT: 'REQUISITION_EXPORT',
  RFQ_VIEW: 'RFQ_VIEW',
  RFQ_CREATE: 'RFQ_CREATE',
  RFQ_EDIT: 'RFQ_EDIT',
  RFQ_SEND: 'RFQ_SEND',
  RFQ_APPROVE: 'RFQ_APPROVE',
  RFQ_DOWNLOAD: 'RFQ_DOWNLOAD',
  RFQ_EXPORT: 'RFQ_EXPORT',
  QUOTATION_VIEW: 'QUOTATION_VIEW',
  QUOTATION_DOWNLOAD: 'QUOTATION_DOWNLOAD',
  QUOTATION_EXPORT: 'QUOTATION_EXPORT',
  QUOTATION_COMPARE: 'QUOTATION_COMPARE',
  QUOTATION_SELECT: 'QUOTATION_SELECT',
  QUOTATION_SEND_TO_VESSEL: 'QUOTATION_SEND_TO_VESSEL',
  QUOTATION_SEND_TO_OWNER: 'QUOTATION_SEND_TO_OWNER',
  QUOTATION_REWORK: 'QUOTATION_REWORK',
  QUOTATION_OWNER_APPROVE: 'QUOTATION_OWNER_APPROVE',
  QUOTATION_OWNER_REJECT: 'QUOTATION_OWNER_REJECT',
  READ_PURCHASE_ORDER: 'READ_PURCHASE_ORDER',
  CREATE_PURCHASE_ORDER: 'CREATE_PURCHASE_ORDER',
  PO_DIRECT_CREATE: 'PO_DIRECT_CREATE',
  UPDATE_PURCHASE_ORDER: 'UPDATE_PURCHASE_ORDER',
  PO_DOWNLOAD: 'PO_DOWNLOAD',
  PO_EXPORT: 'PO_EXPORT',
  PO_SEND: 'PO_SEND',
  PO_SUBMIT_APPROVAL: 'PO_SUBMIT_APPROVAL',
  PO_APPROVE: 'PO_APPROVE',
  PO_REJECT: 'PO_REJECT',
  PO_REWORK: 'PO_REWORK',
  PO_OWNER_APPROVE: 'PO_OWNER_APPROVE',
  PO_OWNER_REJECT: 'PO_OWNER_REJECT',
  PO_VENDOR_LOGISTICS_VIEW: 'PO_VENDOR_LOGISTICS_VIEW',
  PO_VENDOR_LOGISTICS_REQUEST: 'PO_VENDOR_LOGISTICS_REQUEST',
  PO_VENDOR_LOGISTICS_REVIEW: 'PO_VENDOR_LOGISTICS_REVIEW',
  READ_GOODS_RECEIPT: 'READ_GOODS_RECEIPT',
  CREATE_GOODS_RECEIPT: 'CREATE_GOODS_RECEIPT',
  GRN_DOWNLOAD: 'GRN_DOWNLOAD',
  GRN_EXPORT: 'GRN_EXPORT',
  INVOICE_VIEW: 'INVOICE_VIEW',
  INVOICE_CREATE: 'INVOICE_CREATE',
  INVOICE_EDIT: 'INVOICE_EDIT',
  INVOICE_APPROVE: 'INVOICE_APPROVE',
  INVOICE_DOWNLOAD: 'INVOICE_DOWNLOAD',
  INVOICE_EXPORT: 'INVOICE_EXPORT',
  DELIVERY_VIEW: 'DELIVERY_VIEW',
  DELIVERY_CREATE: 'DELIVERY_CREATE',
  READ_DELIVERY_TRACKING: 'READ_DELIVERY_TRACKING',
  CREATE_DELIVERY_TRACKING: 'CREATE_DELIVERY_TRACKING',
  UPDATE_DELIVERY_TRACKING: 'UPDATE_DELIVERY_TRACKING',
  PROCUREMENT_LOG_VIEW: 'PROCUREMENT_LOG_VIEW',
  PROCUREMENT_LOG_EXPORT: 'PROCUREMENT_LOG_EXPORT',
  READ_LIBRARY_CATEGORY: 'READ_LIBRARY_CATEGORY',
  CREATE_LIBRARY_CATEGORY: 'CREATE_LIBRARY_CATEGORY',
  UPDATE_LIBRARY_CATEGORY: 'UPDATE_LIBRARY_CATEGORY',
  DELETE_LIBRARY_CATEGORY: 'DELETE_LIBRARY_CATEGORY',
  LIBRARY_HEAD_VIEW: 'LIBRARY_HEAD_VIEW',
  LIBRARY_HEAD_MANAGE: 'LIBRARY_HEAD_MANAGE',
  LIBRARY_SUBHEAD_VIEW: 'LIBRARY_SUBHEAD_VIEW',
  LIBRARY_SUBHEAD_MANAGE: 'LIBRARY_SUBHEAD_MANAGE',
  LIBRARY_SUBCATEGORY_VIEW: 'LIBRARY_SUBCATEGORY_VIEW',
  LIBRARY_SUBCATEGORY_MANAGE: 'LIBRARY_SUBCATEGORY_MANAGE',
  LIBRARY_ACCOUNTING_VIEW: 'LIBRARY_ACCOUNTING_VIEW',
  LIBRARY_ACCOUNTING_MANAGE: 'LIBRARY_ACCOUNTING_MANAGE',
  LIBRARY_SUBACCOUNTING_VIEW: 'LIBRARY_SUBACCOUNTING_VIEW',
  LIBRARY_SUBACCOUNTING_MANAGE: 'LIBRARY_SUBACCOUNTING_MANAGE',
  LIBRARY_ADDRESS_VIEW: 'LIBRARY_ADDRESS_VIEW',
  LIBRARY_ADDRESS_MANAGE: 'LIBRARY_ADDRESS_MANAGE',
  READ_TERMS_CONDITIONS_LIBRARY: 'READ_TERMS_CONDITIONS_LIBRARY',
  CREATE_TERMS_CONDITIONS_LIBRARY: 'CREATE_TERMS_CONDITIONS_LIBRARY',
  UPDATE_TERMS_CONDITIONS_LIBRARY: 'UPDATE_TERMS_CONDITIONS_LIBRARY',
  DELETE_TERMS_CONDITIONS_LIBRARY: 'DELETE_TERMS_CONDITIONS_LIBRARY',
  READ_APPROVAL_POLICY: 'READ_APPROVAL_POLICY',
  CREATE_APPROVAL_POLICY: 'CREATE_APPROVAL_POLICY',
  UPDATE_APPROVAL_POLICY: 'UPDATE_APPROVAL_POLICY',
  DELETE_APPROVAL_POLICY: 'DELETE_APPROVAL_POLICY',
  ACTIVATE_APPROVAL_POLICY: 'ACTIVATE_APPROVAL_POLICY',
  CLONE_APPROVAL_POLICY: 'CLONE_APPROVAL_POLICY',
  READ_APPROVAL_LIMIT: 'READ_APPROVAL_LIMIT',
  CREATE_APPROVAL_LIMIT: 'CREATE_APPROVAL_LIMIT',
  UPDATE_APPROVAL_LIMIT: 'UPDATE_APPROVAL_LIMIT',
  DELETE_APPROVAL_LIMIT: 'DELETE_APPROVAL_LIMIT',
  READ_CURRENCY_EXCHANGE_RATE: 'READ_CURRENCY_EXCHANGE_RATE',
  CREATE_CURRENCY_EXCHANGE_RATE: 'CREATE_CURRENCY_EXCHANGE_RATE',
  UPDATE_CURRENCY_EXCHANGE_RATE: 'UPDATE_CURRENCY_EXCHANGE_RATE',
  DEACTIVATE_CURRENCY_EXCHANGE_RATE: 'DEACTIVATE_CURRENCY_EXCHANGE_RATE',
  READ_PORT: 'READ_PORT',
  CREATE_PORT: 'CREATE_PORT',
  UPDATE_PORT: 'UPDATE_PORT',
  DEACTIVATE_PORT: 'DEACTIVATE_PORT',
  READ_UOM: 'READ_UOM',
  CREATE_UOM: 'CREATE_UOM',
  UPDATE_UOM: 'UPDATE_UOM',
  DEACTIVATE_UOM: 'DEACTIVATE_UOM',
  DELETE_CURRENCY_EXCHANGE_RATE: 'DEACTIVATE_CURRENCY_EXCHANGE_RATE',
  VENDOR_LIBRARY_VIEW: 'VENDOR_LIBRARY_VIEW',
  VENDOR_LIBRARY_MANAGE: 'VENDOR_LIBRARY_MANAGE',
  USER_PERMISSION_VIEW: 'USER_PERMISSION_VIEW',
  USER_PERMISSION_MANAGE: 'USER_PERMISSION_MANAGE',

} as const

export type ProcurementPermissionCode = (typeof PROCUREMENT_PERMS)[keyof typeof PROCUREMENT_PERMS]

/** Documented runtime aliases for catalogue ↔ legacy procurement guards. */
export const PROCUREMENT_PERMISSION_RUNTIME_ALIASES: Record<string, string[]> = {
  READ_DELIVERY_TRACKING: ['DELIVERY_VIEW'],
  CREATE_DELIVERY_TRACKING: ['DELIVERY_CREATE'],
  UPDATE_DELIVERY_TRACKING: ['DELIVERY_CREATE'],
  DELIVERY_VIEW: ['READ_DELIVERY_TRACKING'],
  DELIVERY_CREATE: ['CREATE_DELIVERY_TRACKING', 'UPDATE_DELIVERY_TRACKING'],
}

export function expandProcurementPermissionCandidates(code: string): string[] {
  const normalized = String(code || '').trim().toUpperCase()
  const out = new Set<string>([normalized])
  for (const alias of PROCUREMENT_PERMISSION_RUNTIME_ALIASES[normalized] || []) {
    out.add(alias)
  }
  return Array.from(out)
}

const normalize = (value: string) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '')

const PROCUREMENT_MENU_PERMISSION_MAP: Record<string, Array<ProcurementPermissionCode | string>> = {
  overview: [PROCUREMENT_PERMS.READ_PROCUREMENT_OVERVIEW],
  requisitions: [PROCUREMENT_PERMS.READ_REQUISITION],
  rfqmanagement: [PROCUREMENT_PERMS.RFQ_VIEW],
  quotationmanagement: [PROCUREMENT_PERMS.QUOTATION_VIEW],
  vendorportal: [PROCUREMENT_PERMS.QUOTATION_VIEW],
  purchaseorders: [PROCUREMENT_PERMS.READ_PURCHASE_ORDER],
  vendorlogisticsrequests: [
    PROCUREMENT_PERMS.PO_VENDOR_LOGISTICS_VIEW,
    PROCUREMENT_PERMS.PO_VENDOR_LOGISTICS_REVIEW,
  ],
  companypoinfo: [PROCUREMENT_PERMS.READ_PURCHASE_ORDER],
  deliverytracking: [PROCUREMENT_PERMS.READ_DELIVERY_TRACKING],
  goodsreceipt: [PROCUREMENT_PERMS.READ_GOODS_RECEIPT],
  invoicemanagement: [PROCUREMENT_PERMS.INVOICE_VIEW],
  invoicematching: [PROCUREMENT_PERMS.INVOICE_VIEW],
  audittrail: [PROCUREMENT_PERMS.PROCUREMENT_LOG_VIEW],
  usermanagement: [PROCUREMENT_PERMS.USER_PERMISSION_VIEW],
  inventory: [
    PROCUREMENT_PERMS.READ_LIBRARY_CATEGORY,
    PROCUREMENT_PERMS.LIBRARY_HEAD_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBHEAD_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBCATEGORY_VIEW,
    PROCUREMENT_PERMS.LIBRARY_ACCOUNTING_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBACCOUNTING_VIEW,
    PROCUREMENT_PERMS.LIBRARY_ADDRESS_VIEW,
    PROCUREMENT_PERMS.READ_TERMS_CONDITIONS_LIBRARY,
    PROCUREMENT_PERMS.READ_APPROVAL_POLICY,
    PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW,
  ],
  approvalworkflow: [
    PROCUREMENT_PERMS.RFQ_VIEW,
    PROCUREMENT_PERMS.READ_PURCHASE_ORDER,
    PROCUREMENT_PERMS.INVOICE_VIEW,
  ],
  approvallibrary: [PROCUREMENT_PERMS.READ_APPROVAL_LIMIT, PROCUREMENT_PERMS.READ_APPROVAL_POLICY],
  currencyexchangerates: [PROCUREMENT_PERMS.READ_CURRENCY_EXCHANGE_RATE],
  vendorlibrary: [PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW],
  vendors: [PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW],
  vendorlist: [PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW],
  vendorcatalogue: [PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW],
}

const PROCUREMENT_ROUTE_PERMISSION_MAP: Record<string, Array<ProcurementPermissionCode | string>> = {
  overview: [PROCUREMENT_PERMS.READ_PROCUREMENT_OVERVIEW],
  requisition: [PROCUREMENT_PERMS.READ_REQUISITION],
  'rfq-management': [PROCUREMENT_PERMS.RFQ_VIEW],
  'quotation-management': [PROCUREMENT_PERMS.QUOTATION_VIEW],
  'crew-quotation-feed': [PROCUREMENT_PERMS.QUOTATION_VIEW],
  'purchase-orders': [PROCUREMENT_PERMS.READ_PURCHASE_ORDER],
  'vendor-logistics-change-requests': [
    PROCUREMENT_PERMS.PO_VENDOR_LOGISTICS_VIEW,
    PROCUREMENT_PERMS.PO_VENDOR_LOGISTICS_REVIEW,
  ],
  'company-po-info': [PROCUREMENT_PERMS.READ_PURCHASE_ORDER],
  'delivery-tracking': [PROCUREMENT_PERMS.READ_DELIVERY_TRACKING],
  'goods-receipt': [PROCUREMENT_PERMS.READ_GOODS_RECEIPT],
  'invoice-management': [PROCUREMENT_PERMS.INVOICE_VIEW],
  'approval-workflow': [
    PROCUREMENT_PERMS.RFQ_VIEW,
    PROCUREMENT_PERMS.READ_PURCHASE_ORDER,
    PROCUREMENT_PERMS.INVOICE_VIEW,
  ],
  'audit-trail': [PROCUREMENT_PERMS.PROCUREMENT_LOG_VIEW],
  'inventory-management': [
    PROCUREMENT_PERMS.READ_LIBRARY_CATEGORY,
    PROCUREMENT_PERMS.LIBRARY_HEAD_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBHEAD_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBCATEGORY_VIEW,
    PROCUREMENT_PERMS.LIBRARY_ACCOUNTING_VIEW,
    PROCUREMENT_PERMS.LIBRARY_SUBACCOUNTING_VIEW,
    PROCUREMENT_PERMS.LIBRARY_ADDRESS_VIEW,
    PROCUREMENT_PERMS.READ_TERMS_CONDITIONS_LIBRARY,
    PROCUREMENT_PERMS.READ_APPROVAL_POLICY,
    PROCUREMENT_PERMS.VENDOR_LIBRARY_VIEW,
  ],
  'approval-library': [PROCUREMENT_PERMS.READ_APPROVAL_LIMIT, PROCUREMENT_PERMS.READ_APPROVAL_POLICY],
  'currency-exchange-rates': [PROCUREMENT_PERMS.READ_CURRENCY_EXCHANGE_RATE],
  'user-management': [PROCUREMENT_PERMS.USER_PERMISSION_VIEW],
}

export const getRequiredPermissionsForProcurementMenu = (
  menuLabel: string
): Array<ProcurementPermissionCode | string> | null => {
  return PROCUREMENT_MENU_PERMISSION_MAP[normalize(menuLabel)] || null
}

export const getRequiredPermissionsForProcurementRoute = (
  routeSegment: string
): Array<ProcurementPermissionCode | string> | null => {
  return PROCUREMENT_ROUTE_PERMISSION_MAP[String(routeSegment || '').trim().toLowerCase()] || null
}
